module.exports = __webpack_public_path__ + "static/media/check.472e24bc.svg";